/**
 * @file Inline Google "G" mark for the "Continue with Google" button.
 * @module @labcraft/ui/chrome/sign-in/google-logo
 *
 * Vendor brand mark per [Google Identity branding
 * guidelines](https://developers.google.com/identity/branding-guidelines).
 * The four colors are Google's official palette and must NOT inherit
 * `currentColor` — these are fixed brand colors, not theme tokens.
 *
 * Inline rather than fetched so the SVG ships in the JS bundle (no
 * extra request, no flash). 18px default sizing matches the GitHub
 * mark sibling so the two SSO buttons feel uniform.
 */

import type { JSX, SVGProps } from 'react'

/** Props are pass-through to the underlying `<svg>`. */
type LogoProps = SVGProps<SVGSVGElement>

/**
 * Google "G" multicolor logo. Pass `width`/`height` (defaults 18) or
 * size via CSS. `aria-hidden` by default — the surrounding button
 * label provides accessible naming.
 */
export function GoogleLogo(props: LogoProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width={18} height={18} aria-hidden {...props}>
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  )
}
